/**
 * Get the integer portion of the value
 * @param {string|undefined}  value
 */
export const getInteger = value => {
  return value ? Math.abs(Number(value.split('.')[0])).toString() : undefined;
};